import { Box, type CloudImageProps } from "@biom3/react";
import { useCallback, useEffect, useState } from "react";

export type ParallaxWrapperProps = {
  children: React.ReactNode;
  intensity?: number;
  sx?: CloudImageProps["sx"];
};

export const ParallaxWrapper: React.FC<ParallaxWrapperProps> = ({
  sx,
  children,
  intensity = 0.05,
}) => {
  const [offset, setOffset] = useState({ x: 0, y: 0 });

  const handleMouseMove = useCallback(
    (event: MouseEvent) => {
      const { innerWidth, innerHeight } = window;
      const x = (event.clientX - innerWidth / 2) * intensity;
      const y = (event.clientY - innerHeight / 2) * intensity;
      setOffset({ x, y });
    },
    [intensity],
  );

  useEffect(() => {
    window.addEventListener("mousemove", handleMouseMove);
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, [handleMouseMove]);

  return (
    <Box
      sx={{
        ...sx,
        transform: `translate(${offset.x}px, ${offset.y}px)`,
        transition: "transform 0.1s ease-out",
      }}
    >
      {children}
    </Box>
  );
};
